import { render, staticRenderFns } from "./DonutChart36.vue?vue&type=template&id=7ec86d23&scoped=true"
import script from "./DonutChart36.vue?vue&type=script&lang=js"
export * from "./DonutChart36.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec86d23",
  null
  
)

export default component.exports